import { IHttpClient } from "@mojang/http";
import { accountsPublicService } from "./accountsPublicService";

export interface IUserDetails {
  dateOfBirth: number;
  email: string;
  emailVerified: boolean;
  emailOfParent: string;
  hashed: boolean;
  id: string;
  legacyUser: boolean;
  registerIp: string;
  registeredAt: number;
  secured: boolean;
  verifiedByParent: boolean;
}

export type AccountAPI = {
  getUser: () => Promise<{ data: IUserDetails; error: boolean }>;
};

export function accountAPI(
  http: IHttpClient = accountsPublicService
): AccountAPI {
  return {
    getUser: async function getUser() {
      try {
        const response = await http.get<IUserDetails>("user");

        if (response.ok) {
          return { data: await response.json(), error: false };
        }
      } catch (error) {
        return { data: null, error: true };
      }

      return { data: null, error: false };
    },
  };
}
